import _extends from "@babel/runtime/helpers/extends";
/** @jsx jsx */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import Action from '../action';
import { FormattedMessage } from 'react-intl-next';
import { messages } from '../../../../../messages';
import { useFlexibleUiContext } from '../../../../../state/flexible-ui-context';
import RelatedLinksActionIcon from './related-links-action-icon';
import { lazy, useCallback } from 'react';
import { useSmartLinkModal } from '../../../../../state/modal';
const RelatedLinksModal = /*#__PURE__*/lazy(() => import( /* webpackChunkName: "@atlaskit-internal_smartcard-RelatedLinksModal" */'../../../../RelatedLinksModal'));
const ViewRelatedLinksAction = ({
  onClick: onClickCallback,
  ...props
}) => {
  var _context$actions;
  const modal = useSmartLinkModal();
  const context = useFlexibleUiContext();
  const actionData = context === null || context === void 0 ? void 0 : (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions.ViewRelatedLinksAction;
  const onClick = useCallback(() => {
    const url = actionData === null || actionData === void 0 ? void 0 : actionData.url;
    if (url) {
      modal.open(jsx(RelatedLinksModal, {
        url: url,
        showModal: true,
        onClose: () => modal.close()
      }));
    }
    onClickCallback === null || onClickCallback === void 0 ? void 0 : onClickCallback();
  }, [actionData === null || actionData === void 0 ? void 0 : actionData.url, modal, onClickCallback]);
  return actionData ? jsx(Action, _extends({
    content: jsx(FormattedMessage, messages.related_links_view_related_urls),
    icon: jsx(RelatedLinksActionIcon, null),
    onClick: onClick,
    testId: "smart-action-view-related-links-action",
    ariaLabel: "View most recent pages or content types coming from or found on this link"
  }, props)) : null;
};
export default ViewRelatedLinksAction;